import React, { useContext, useEffect, useState } from "react";
import * as S from "./Message.style"
import { ThemeContext } from 'styled-components';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function Message({ 
  message, 
  option, 
  time, 
  date, 
  senderName, 
  link,
  children,
  file
}) {

  const theme = useContext(ThemeContext);
  
  const [isImageFile, setIsImageFile] = useState(null);  
  const [loadingFile, setLoadingFile] = useState(false);

  const messageEdited = message ? message.replace('{{medicine}}','') : "";
  const colorByType = message && message.includes("{{medicine}}") ? theme.primarySectionMedicines : "";

  function renderMessage(children, link, messageEdited) {
    let message;
    if (children) {
      message = children;
    } else {
      message = messageEdited;
    }
    return message;
  }

  function checkIfImage(url) {
    setLoadingFile(true);
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve(true);
        setLoadingFile(false);
      };
      img.onerror = () => {
        resolve(false);
        setLoadingFile(false);
      };
      img.src = url;
    });
  }

  function getFileNameFromUrl(url) {    
    return url.split('/').pop().split('?')[0].split('#')[0];
  }

  useEffect(() => {
    async function checkFile() {
      if (file) {
        const isImage = await checkIfImage(file);
        setIsImageFile(isImage);
      }
    }
    checkFile();
  }, []);

  function openFile() {
    window.open(file, "_blank", "noopener,noreferrer");
  }

  const reactMarkdownComponents = (text) => {
    return (
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          strong: ({ children }) => (
            <strong style={{ fontWeight: "bold" }}>{children}</strong>
          ),
          em: ({ children }) => (
            <em style={{ fontStyle: "italic" }}>{children}</em>
          ),
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2a4bd7", wordBreak: "break-word" }}
            >
              {children}
            </a>
          ),
          ul: ({ children }) => (
            <ul style={{ paddingLeft: "1.5em", listStyleType: "disc", margin: 0 }}>
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol style={{ paddingLeft: "1.5em", listStyleType: "decimal", margin: 0 }}>
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li style={{ wordBreak: "break-word", marginBottom: "0.75em" }}>
              {children}
            </li>
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    )
  };
    

  return (
    <S.Message 
      time={time} 
      option={option} 
      color={colorByType}
      >
      <div className="message__sender-name">{senderName}</div> 
      { option === 'doctor' ? 
        <div className="message message--patient" time={time}>
          {
            children
            ? children
            : reactMarkdownComponents(messageEdited)

          }
        </div> :
        <div className="message message--reciever">
          {
            children
            ? renderMessage(children, link, messageEdited)
            : reactMarkdownComponents(
              renderMessage(children, link, messageEdited)
            )
          }
        </div>
      }
      {
        time && date ? 
        <div className="message__time">{time} • {date}</div> : null
      }
      {
        option === 'doctor' 
        ? <div className="message__tail--patient">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
            <path d="M19 16.7502C9.89773 18.4052 2.96759 13.6472 0.640306 11.0613L0.898893 3.30368C3.39857 3.82085 8.81166 4.28631 10.4666 2.01074C10.208 11.3199 17.1899 15.9745 19 16.7502Z" fill="#1F1F52" stroke="#1F1F52" stroke-width="0.805851"/>
          </svg>
        </div>
        : <div className="message__tail--reciever">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
            <path d="M2 16.7502C11.1023 18.4052 18.0324 13.6472 20.3597 11.0613L20.1011 3.30368C17.6014 3.82085 12.1883 4.28631 10.5334 2.01074C10.792 11.3199 3.81011 15.9745 2 16.7502Z" fill="#E8E7F4" stroke="#E8E7F4" stroke-width="0.805851"/>
          </svg>
        </div>
      }
    </S.Message>
  );
}

export default Message;
